import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from '../../components/common/breadcrumb';
import { FrontDesk_URL } from '../../constant';
import { Admin_URL } from '../../constant';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import DynamicDataTable from '../commonComponent/DataTable/DataTables';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';
import { Spinner } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import { saveAs } from 'file-saver';

const ServiceWiseCollections = () => {
    let fromDate = useRef();
    let toDate = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [CentreId, setCentreId] = useState(localStorage.CentreSNo == undefined ? "" : localStorage.CentreSNo);
    const [LoginId, setLoginId] = useState(localStorage.uId == undefined ? "" : localStorage.uId);
    const [LGlCentreTypeoption, SetLGlCentreTypeoption] = useState([]);
    const abortControllerRef = useRef(null);
    // const [table, setTable] = useState([]);
    const [tableData, setTableData] = useState({
        PageNo: 1,
        PageSize: 100,
        TotalRecord: 0,
        Rows: []

    });
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [downloadvisible, setDownloadVisible] = useState(false);
    const [CSVData, setCSVData] = useState([]);
    const [defaultDate, setDefaultDate] = useState("");

    useEffect(() => {
        const today = new Date();
        const date = today.setDate(today.getDate());
        const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
        setDefaultDate(defaultValue);
        //BindGrid(defaultValue, defaultValue,tableData.PageNo, tableData.PageSize);
    }, []);
    const paginationOptions = {
        totalSize: tableData.TotalRecord,
        sizePerPage: tableData.PageSize,
        showTotal: true,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); BindGrid(fromDate.current.value, toDate.current.value,page, sizePerPage); },
        onSizePerPageChange: (sizePerPage, page, event) => { BindGrid(fromDate.current.value, toDate.current.value,page, sizePerPage); document.getElementsByClassName('dropdown-menu show')[0].classList.remove('show'); },
    };
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <span>{crntPageNO + rowIndex + 1}</span>
            </div>
        </React.Fragment>
    }
    const columns = [
    { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
    { dataField: 'ClientCode', text: 'Client Code', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'ClientName', text: 'Client Name', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'PartnerType', text: 'Partner Type', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'BusinessCode', text: 'Business Code', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'BusinessName', text: 'Business Name', editable: false,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'OrderNO', text: 'Order No', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },              // API me 'OrderNO' (NO capital)
    { dataField: 'OrderDate', text: 'Order Date', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'BillNo', text: 'Bill No', editable: false,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'BillDate', text: 'Bill Date', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'UHID', text: 'UHID', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'VisitingCode', text: 'Visiting Code', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'PatientName', text: 'Patient Name', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'Age', text: 'Age', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'GenderName', text: 'Gender Name', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'MobileNo', text: 'Mobile No', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'TestCode', text: 'Test Code', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'DepartmentName', text: 'Department Name', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'ItemName', text: 'Item Name', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'DoctorName', text: 'Doctor Name', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'PROName', text: 'PRO Name', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'OtherLabRefNo', text: 'Other Lab Ref No', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'MRP', text: 'MRP', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'GrossAmount', text: 'Gross Amount', editable: false ,  headerStyle: { width: '%', fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'Discount', text: 'Discount', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'NetAmount', text: 'Net Amount', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'QTY', text: 'Qty', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},                       // API me 'QTY' (all caps)
    { dataField: 'BillingType', text: 'Billing Type', editable: false ,  headerStyle: { fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'PaymentStatus', text: 'Payment Status', editable: false ,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 }},
    { dataField: 'OutstandingEmployee', text: 'Outstanding', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },// dekho note #1
    { dataField: 'UserName', text: 'User Name', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } },
    { dataField: 'HomeCollection', text: 'Home Collection Discount', editable: false,  headerStyle: {  fontSize: 10 }, style:{width: '5%', fontSize: 10 } }, // API me 'HomeCollection'
    { dataField: 'Source', text: 'Source', editable: false,  headerStyle: {fontSize: 10 }, style:{width: '5%', fontSize: 10 } }
];
    const BindGrid = async (fromDateSelected, toDateSelected,PageNo,PageSize,filtertype) => {
        setIsLoading(true);
        const  ObjServiceCollection= {
            CentreId:localStorage.getItem('CentreSNo'),
            FromDate:fromDateSelected,
            ToDate:toDateSelected,
            PageNo:`${PageNo}`,
            PageSize:`${PageSize}`,
            IsExcelD:`${0}`
        };        
        try {
            let url = FrontDesk_URL + 'reports/GetServicewiseCollectionReport'
            await axios.post(url,ObjServiceCollection).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null) { 
                         if(data.Data.SerViceList!=null && data.Data.SerViceList.length>0)
                        {
                            setTableData({
                                ...tableData,
                                PageSize: Number(PageSize),
                                TotalRecord: Number(data.Data.TotalRecord),
                                Rows: data.Data.SerViceList
                            });
                        }
                        
                        //setTable(data.Data);
                     }
                    else {  setTableData([]); }
                    setIsLoading(false);
                }
                setIsLoading(false);
            }).catch(function (error) { setIsLoading(false);} );
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); setIsLoading(false);}
    }
    const GetReportData = async (fromDateSelected, toDateSelected,PageNo,PageSize) => {
        setIsLoading(true);
        setDownloadVisible(false);
        const  ObjServiceCollection= {
            CentreId:localStorage.getItem('CentreSNo'),
            FromDate:fromDateSelected,
            ToDate:toDateSelected,
            PageNo:`${PageNo}`,
            PageSize:`${PageSize}`,
            IsExcelD:`${1}`
        };        
        try {
            let url = FrontDesk_URL + 'reports/GetServicewiseCollectionReport'
            await axios.post(url,ObjServiceCollection).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null && data.Data.SerViceList.length>0) {
                        setDownloadVisible(true);
                        setCSVData(data.Data.SerViceList);
                        document.getElementById("csvdownload").click();
                    }
                    else { setCSVData([]); }
                }
                setIsLoading(false);
            }).catch(function (error) { });
            setIsLoading(false);
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
        setIsLoading(false);
    }
    const handleSearch = async () => {
        BindGrid(fromDate.current.value, toDate.current.value,tableData.PageNo, tableData.PageSize);
    }
    const handleDownload = async () => {
        // GetReportData(fromDate.current.value, toDate.current.value,tableData.PageNo, tableData.PageSize);
        GetReportData_CSV(fromDate.current.value, toDate.current.value,tableData.PageNo, tableData.PageSize,"1");
    }


    const GetReportData_CSV = async (fromDateSelected, toDateSelected, PageNo, PageSize, filtertype) => {
  try {
    // Create AbortController for request cancellation
    const TypeOptL = [];
    const TypeOptrows = {'CentreId': localStorage.getItem('CentreSNo')};
    TypeOptL.push(TypeOptrows);
    SetLGlCentreTypeoption(TypeOptL);

    const controller = new AbortController();

    // Keep in ref if you want external cancel tracking
    abortControllerRef.current = controller;

    setIsLoading(true);
    setDownloadVisible(false);

    const ObjServiceCollection = {
      UserId: localStorage.getItem('LoggedInUser'),
      FromDate: fromDateSelected,
      ToDate: toDateSelected,
      objtblCentreIds: TypeOptL,
      PageNo: `${PageNo}`,
      PageSize: `${PageSize}`,
      IsExcelD: "1",
      FilterType: filtertype
    };
    const url_data = "https://localhost:44310/api/";
    const url = `${Admin_URL}reports/DownloadCsvServicewiseCollectionReport`;

    console.log("Downloading CSV from:", url);

    const response = await axios.post(url, ObjServiceCollection, {
      responseType: 'blob',
      headers: {
        'Accept': 'text/csv'
      },
      signal: controller.signal // Enables AbortController cancellation
    });

    // Check for successful response and handle blob
    if (response.status === 200) {
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'ServicewiseCollectionReport.csv');
    } else {
      console.error('Error: Non-200 status code', response.status);
    }

  } catch (error) {
    if (axios.isCancel(error)) {
      console.warn('CSV download was cancelled by user.');
    } else if (error.name === 'CanceledError') {
      console.warn('Request cancelled due to AbortController.');
    } else {
      console.error('Error downloading CSV file:', error);
    }
  } finally {
    setIsLoading(false);
  }
};

const handleView = async () => {
    const from = fromDate.current.value;
    const to = toDate.current.value;

    // dono date required
    if (!from || !to) {
        SweetAlert.fire({ title: "Required!", text: "Please select both From Date and To Date.", icon: "warning" });
        return;
    }

    const fromDt = new Date(from);
    const toDt = new Date(to);

    // To Date, From Date se chhoti na ho
    if (toDt < fromDt) {
        SweetAlert.fire({ title: "Invalid Date!", text: "To Date cannot be earlier than From Date.", icon: "warning" });
        return;
    }

    // 2 din se jyada gap allowed nahi
    const diffDays = Math.floor((toDt - fromDt) / (1000 * 60 * 60 * 24));
        if (diffDays > 2) {
        SweetAlert.fire({ title: "Date range too large!", text: "Please select a date range where the gap is not more than 3 days.", icon: "warning" });
        return;
    }

    GetReportData_View(from, to,tableData.PageNo, tableData.PageSize,"1");
};

const GetReportData_View = async (fromDateSelected, toDateSelected, PageNo, PageSize, filtertype) => {
  try {
    const TypeOptL = [];
    TypeOptL.push({ 'CentreId': localStorage.getItem('CentreSNo') });
    SetLGlCentreTypeoption(TypeOptL);

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoading(true);

    const ObjServiceCollection = {
      UserId: localStorage.getItem('LoggedInUser'),
      FromDate: fromDateSelected,
      ToDate: toDateSelected,
      objtblCentreIds: TypeOptL,
      PageNo: `${PageNo}`,
      PageSize: `${PageSize}`,
      IsExcelD: "1",
      FilterType: filtertype
    };

    const url = `${Admin_URL}reports/GetServicewiseCollectionReportData`;

    const response = await axios.post(url, ObjServiceCollection, {
      signal: controller.signal
    });

    const data = response.data;
    if (data.Success && data.Data != null && data.Data.SerViceList != null && data.Data.SerViceList.length > 0) {
      setTableData({
        ...tableData,
        PageSize: Number(PageSize),
        TotalRecord: Number(data.Data.TotalRecord),
        Rows: data.Data.SerViceList
      });
    } else {
      setTableData({ ...tableData, TotalRecord: 0, Rows: [] });
    }
  } catch (error) {
    if (axios.isCancel(error) || error.name === 'CanceledError') {
      console.warn('View request cancelled.');
    } else {
      SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" });
    }
  } finally {
    setIsLoading(false);
  }
};


    return (
        <React.Fragment>
            <Breadcrumb title="Servicewise Collection" parent="Reports" />
            <Container fluid>
                <Row className='mt25'>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>From Date</Form.Label>
                                            <InputGroup className="mb-3 d-flex justify-content-start">
                                                <Form.Control type="date" id="fromDate" name="fromDate" ref={fromDate} defaultValue={defaultDate} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>To Date</Form.Label>
                                            <InputGroup className="mb-3 d-flex justify-content-start">
                                                <Form.Control type="date" id="toDate" name="toDate" ref={toDate} defaultValue={defaultDate} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className='topmargin30'>
                                        {/*<Button variant='secondary' onClick={handleSearch}>Search</Button>*/}
                                        {
                                            isLoading ?
                                            <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                            <><Button className='ml-2' variant='primary' onClick={handleDownload}>Download CSV</Button>
                                              <Button className='ml-2' variant='secondary' onClick={handleView}>View</Button>
                                            </>
                                        }
                                    </Col>
                                    <Col lg={12} md={12} className='TableDynamic' style={{ position: 'relative' }}>
                                    {
                                        isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <>
                                        <DynamicDataTable
                                            keyField='BillNo'
                                            tableData={tableData.Rows}
                                            columns={columns}
                                            noDataIndication={NoRecordFounds}
                                            pagination={paginationOptions ? paginationFactory(paginationOptions) : null}

                                        />
                                        </>
                                    }
                                </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {
                    downloadvisible &&
                    <CSVLink data={CSVData} filename="ServicewiseReport.csv" target="_blank" id="csvdownload"></CSVLink>
                }
            </Container>
        </React.Fragment>
    )
          
}
export default ServiceWiseCollections;